
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabaseClient';

interface SimpleAuthCheckerProps {
  children: React.ReactNode;
}

export const SimpleAuthChecker: React.FC<SimpleAuthCheckerProps> = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;
    
    const checkAuth = async () => {
      try {
        console.log('[SimpleAuthChecker] Checking authentication');
        
        // For now, bypass auth check and just show the app
        // This will let us see if the app loads properly
        console.log('[SimpleAuthChecker] Bypassing auth for debugging');
        if (mounted) {
          setAuthenticated(true);
          setLoading(false);
        }
        
      } catch (err) {
        console.error('[SimpleAuthChecker] Auth check failed:', err);
        if (mounted) {
          setAuthenticated(true); // Still show the app
          setLoading(false);
        }
      }
    };

    // Very short timeout
    const timeoutId = setTimeout(() => {
      if (mounted && loading) {
        console.log('[SimpleAuthChecker] Timeout reached, showing app');
        setAuthenticated(true);
        setLoading(false);
      }
    }, 500);

    checkAuth();

    return () => {
      mounted = false;
      clearTimeout(timeoutId);
    };
  }, []);

  if (loading) {
    return (
      <div 
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          backgroundColor: '#ffffff',
          flexDirection: 'column'
        }}
        data-testid="auth-loading"
      >
        <div style={{
          width: '32px',
          height: '32px',
          border: '3px solid #e5e7eb',
          borderTop: '3px solid #3b82f6',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          marginBottom: '1rem'
        }} />
        <p style={{ color: '#6b7280', fontSize: '0.875rem' }}>
          Loading LiveTrack...
        </p>
        <style>
          {`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}
        </style>
      </div>
    );
  }

  // Always render children for now to debug the loading issue
  return <>{children}</>;
};
